<template lang="pug">
  div.filter-panel
    header
      div.name 筛选
      button.toggle(@click="toggle")
        i.icon.iconfont.icon-down-arrow
    div.tags
      //- Tags
      slot(name="addedOption") please add addedOption
    div.options
      CommonCondition(v-for="(item, i) in filters"
                      :key="i",
                      :filter="item"
                      :addFilterCondition="addFilterCondition",
                      :clearItem="clearItem",
                      :clearAllItems="clearAllItems")
      //- ColorCondition

</template>
<script>
import Tags from '@/components/Special/Tags.vue'
import CommonCondition from '@/components/Special/CommonCondition.vue'
import ColorCondition from '@/components/Special/ColorCondition.vue'
export default {
  name: 'FilterPanel',
  props: {
    toggle: {
      type: Function
    },
    clearItem: {
      type: Function
    },
    clearAllItems: {
      type: Function
    },
    addFilterCondition: {
      type: Function
    },
    filters: {
      type: Array
    }
  },
  components: {
    Tags,
    CommonCondition,
    ColorCondition
  }
}
</script>
<style lang = "scss" scoped>
.filter-panel {
  position: relative;
  header {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    font-size: 1.375rem;
    background: #1a1a1a;
    color: #fff;
    line-height: 1em;
    height: 3.4375rem;
    padding: 0 1.25rem;
    button {
      border: none;
      background: transparent;
    }
  }
  button {
    color:#fff;
    .icon {
      font-size: 1.5rem;
      }
  }

}

</style>
